import { createAsyncThunk } from "@reduxjs/toolkit";
import { db } from "../../../firebase/config";
import { TalesProgramma } from "../../../utils/types/TalesProgramma";

export const toggleProgrammaVisibility = createAsyncThunk(
  "programma/toggleVisibility",
  async (programma: TalesProgramma) => {
    try {
      const querySnapshot = await db
        .collection("programma")
        .where("title", "==", programma.title)
        .get();

      return querySnapshot.docs[0].ref.set({
        ...programma,
        show: !programma.show,
      });
    } catch (e: any) {
      console.log(e);

      return Promise.reject(
        `Programma non ${programma.show ? "nascosto" : "mostrato"}, ${e.message}`,
      );
    }
  },
);
